module.exports = __webpack_public_path__ + "img/indm.56522a01.png";